<template>
  <b-alert variant="info" class="d-flex flex-column mb-4" show>
    <div class="h6-size semibold d-flex" style="gap: 5px">
      <span>Check-in Online</span>
    </div>
    <p class="d-flex flex-column text-content" style="font-size: 12px">
      <span>
        24 ore prima della partenza ricorda di fare il check-in online
        sul sito della compagnia aerea e di scaricare le carte
        d’imbarco.
      </span>
      <span>
        Attenzione! Prendi nota di queste credenziali con cui effettuare
        l’accesso:
      </span>
    </p>
    <p class="d-flex flex-column" style="font-size: 12px">
      <span class="d-flex" style="gap: 5px">
        <strong class="text-content">Numero di prenotazione:</strong>
        <strong>{{ carrier_reference }}</strong>
      </span>
      <span class="d-flex" style="gap: 5px">
        <strong class="text-content">Mail:</strong>
        <strong>{{ email_pnr }}</strong>
      </span>
    </p>
    <p class="d-flex flex-column text-content" style="font-size: 12px">
      Fare il chekin online è semplice: entra nella tua area riservata e
      segui le istruzioni della compagnia. Per dubbi o assistenza siamo a
      disposizione.
    </p>
  </b-alert>
</template>

<script>
export default {
  name: "checkin-online-alert",

  props: {
    // codice/numero di prenotazione presso la compagnia (carrierReference)
    carrier_reference: {
      type: String,
      default: "",
    },
    // email associata al PNR per il check-in
    email_pnr: {
      type: String,
      default: "",
    },
  },
};
</script>